/**
 * dir-w | backOffice
 * Repository to manage CRUD data operations
 * - get
 * - patch
 * - delete
 * - post
 * - put
 *
 * Last update : July 21, 2024 | @rizkiprasetya
 */
// import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Configuration } from '../config/configuration';
import { TokenService } from '../services/token.service';

// @Injectable({ providedIn: 'root' })

export class BaseCrudRepository {
  constructor(protected http: HttpClient) {}

  /**
   * Read data | Compile list data as collection
   * @param _endPoint
   * @param _listParams
   * @returns
   */
  protected get(
    _endPoint: string,
    _listParams: Array<{ key: string; value: string }> | []
  ): Observable<any> {
    return this.http.get<any>(_endPoint, {
      headers: Configuration.generateHttpHeaders(TokenService.token()),
      params: Configuration.generateHttpParams(_listParams),
    });
  }

  /**
   * Partial update data, body may contains null value
   * @param _endPoint
   * @returns
   */
  protected patch(_endPoint: string, _body: any | null): Observable<any> {
    return this.http.patch<any>(_endPoint, _body, {
      headers: Configuration.generateHttpHeaders(TokenService.token()),
    });
  }

  /**
   * Delete data
   * @param _endPoint
   * @returns
   */
  protected delete(_endPoint: string): Observable<any> {
    return this.http.delete<any>(_endPoint, {
      headers: Configuration.generateHttpHeaders(TokenService.token()),
    });
  }

  /**
   * Create data
   * @param _endPoint
   * @param _body
   * @returns
   */
  protected post(_endPoint: string, _body: any, _useContentType: boolean = true): Observable<any> {
    return this.http.post<any>(_endPoint, _body, {
      headers: Configuration.generateHttpHeaders(TokenService.token(), _useContentType)});
  }

  /**
   * Create data with progress events
   * @param _endPoint
   * @param _body
   * @returns
   */
  protected postWithProgress(_endPoint: string, _body: FormData | null): Observable<any> {
    return this.http.post<any>(_endPoint, _body, {
      headers: Configuration.generateHttpHeaders(TokenService.token()),
      reportProgress: true, observe: 'events'
    });
  }

  /**
   * Update data
   * @param _endPoint
   * @param _body
   * @returns
   */
  protected put(_endPoint: string, _body: any): Observable<any> {
    return this.http.put<any>(_endPoint, _body, {
      headers: Configuration.generateHttpHeaders(TokenService.token()),
    });
  }
}
